<template>
  <div class="e-container" ref="main"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    option: {
      deep: true,
      handler(val) {
        if (this.chart) {
          this.chart.setOption(
            {
              ...val
            },
            true
          );
        }
      },
      immediate: true
    }
  },

  methods: {
    init(option) {
      this.chart = echarts.init(this.$refs.main);
      this.chart.setOption(option);

      this.chart.on('datazoom', params => {
        this.$emit('datazoom', params);
      });

      this.chart.on('brush', params => {
        this.$emit('brush', params);
      });
    }
  },
  mounted() {
    this.init(this.option);
  },
  beforeDestroy() {
    this.chart.dispose();
  }
};
</script>

<style>
.e-container {
  height: 100%;
  width: 100%;
}
</style>
